<template>
  <div class="container">
    <h1>Test</h1>
    <div class="ui message">
      <div class="header">JCSteele Test</div>
    </div>
  </div>
</template>

<script>
import APIService from "@/assets/js/APIService";
const apiService = new APIService(this);

export default {
  name: "AdminTest",
  computed: {},
  data() {
    return {
      admin: true
    };
  },
  mounted() {
    this.apiTest();
  },
  methods: {
    apiTest() {
      apiService.test().then(data => {
        // console.log(data);
        return data;
      });
    }
  }
};
</script>
